module.exports = __webpack_public_path__ + "assets/images/basic-circle-93f7e3ee70b27b00ff00a2e3f6a848a2.png";